import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { Component, Inject, OnDestroy, OnInit } from "@angular/core";
import { ApiService } from "src/app/providers/api.service";
import { Subscription } from "rxjs";
import { SM_CONSTANTS } from "src/app/shared/constants/sm-constants";
import { LoaderServiceService } from "src/app/providers/loader-service.service";
import { AlertService } from "src/app/providers/alert.service";

@Component({
  selector: 'sm-public-post-settings',
  templateUrl: './public-post-settings.component.html',
  styleUrls: ['./public-post-settings.component.scss']
})
export class PublicPostSettingsComponent implements OnInit, OnDestroy {
  apisub: Subscription;
  toShowCheck: number = 0;
  constructor(
    @Inject(MAT_DIALOG_DATA) public parentdata: any,
    private apiservice: ApiService,
    private ls: LoaderServiceService,
    private activemodal: MatDialogRef<PublicPostSettingsComponent>,
        private as:AlertService

  ) {
    this.apisub = this.apiservice.apiResult.subscribe((resdata) => {
      if (
        resdata.responseType ===
        SM_CONSTANTS.RESULT_API_GET_PUBLIC_POSTING_PERMISSION_STATUS
      ) {
        if (resdata.result) {
          this.toShowCheck = resdata.result.allow_public_posting;
        }

        this.ls.showLoader = false;
      }
      if (
        resdata.responseType ===
        SM_CONSTANTS.RESULT_API_SET_ENTITY_PUBLIC_POST_PERMISSION_STATUS
      ) {
        if (resdata.result) {
          this.ls.showLoader = false;
                    this.as.onOpenSnackbar("Public post settings saved successfully.",3000)

          this.activemodal.close({ msg: "success" });
        }
      }
    });
  }

  ngOnInit(): void {
    this.apiservice.getPublicPostingPermissionStatus(
      this.parentdata.entityHash,
    );
  }

  onToggleChange(event: any) {
  
      // -------- CHECK LOGIC-----------
      if (event.checked) {
        this.toShowCheck = 1;
      }
      // -------- UNCHECK LOGIC -------------
      else if (!event.checked) {
        this.toShowCheck = 0;
      }
  }

  onSave() {
    let obj = {
      entity_hash: this.parentdata.entityHash,
      permission_status: this.toShowCheck,
    };

    console.log(obj);

    this.ls.showLoader = true;
    this.apiservice.setEntityPublicPostPermissionStatus(obj);
  }

  ngOnDestroy(): void {
    this.apisub.unsubscribe();
  }
}
